/** @jsx h */
import { h, Component } from 'preact'
import { getBounds } from 'geolib'
import * as qs from 'querystringify'

import load from './utils/load'
import Map from './Map'
import Cluster from './Cluster'
import VenueShow from './VenueShow'
import Fetch from './Fetch'

import { Client } from '../api'
import geolocation from './utils/geolocation'

const HERE_MAPS_APIKEY = '_KW7JJPELxsR7Gq95E--BG1E0_iWkPIGhImTYwADXcg'

const HERE_MAPS_ASSETS = [
  'https://js.api.here.com/v3/3.1/mapsjs-ui.css',
  'https://js.api.here.com/v3/3.1/mapsjs-core.js',
  'https://js.api.here.com/v3/3.1/mapsjs-service.js',
  'https://js.api.here.com/v3/3.1/mapsjs-mapevents.js',
  'https://js.api.here.com/v3/3.1/mapsjs-ui.js',
  'https://js.api.here.com/v3/3.1/mapsjs-clustering.js'
]

const DEFAULT_ZOOM = 14
const DEFAULT_VIEW_BOUNDS = {
  top: 47.215835,
  left: -2.848994,
  bottom: 55.425895,
  right: 22.859013
}

function transformVenueData (data) {
  if (!data) {
    return null
  }

  const appointments = data.included.map(r => ({ ...r.attributes, id: r.id }))
  const attributes = data.data.attributes

  return { ...{ ...attributes, appointments } }
}

class Widget extends Component {
  state = {
    error: null,
    booting: true,
    loading: false,
    search: {
      term: this.props.term,
      startOn: this.props.start_on,
      endOn: this.props.end_on
    },
    map: {
      zoom: 11,
      center: { lat: null, lng: null },
      viewBounds: {},
      dirty: false
    },
    venues: {
      all: [],
      selected: null
    }
  }

  componentDidMount () {
    this.urls = {}
    for (let name in this.props.urls) {
      this.urls[name] = (params) => {
        const template = this.props.urls[name]
        let url = template.replace(/:(\w+)/g, (match, key) => {
          const value = params[key]
          if (!value) return match
          delete params[key]
          return value
        })
        url += qs.stringify(params, true)
        return url
      }
    }
    this.api = Client({ urls: this.urls })

    load(HERE_MAPS_ASSETS)
        .then(() => {
          this.setState({ booting: false })
        })
        .catch(error => this.setState({ error }))
  }

  selectVenue = (event) => {
    const venue = event.target.getData()

    this.setState(({ venues }) => ({
      venues: {
        ...venues,
        selectedId: venue.id
      }
    }))
  }

  handleMapViewChanged = (event) => {
    const hereMap = event.currentTarget

    // HACK: viewBounds.getTop() is not precise e.g. it returns always different values.
    this.hereMap = hereMap

    this.setState(({ map, search, venues }) => ({
      search: {
        ...search,
        term: null
      },
      map: {
        ...map,
        zoom: hereMap.getZoom(),
        center: hereMap.getCenter(),
      }
    }))
  }

  handleDragStart = (event) => {
    this.setState(({ map }) => ({
      map: {
        ...map,
        dirty: true
      }
    }))
  }

  handleWheel = (event) => {
    this.setState(({ map }) => ({
      map: {
        ...map,
        dirty: true
      }
    }))
  }

  searchWithinBounds = () => {
    const viewBounds = this.hereMap.getViewModel().getLookAtData().bounds.getBoundingBox()
    this.setState(({ map }) => ({
      loading: true,
      map: {
        ...map,
        viewBounds: {
          top: viewBounds.getBottom(),
          left: viewBounds.getLeft(),
          bottom: viewBounds.getTop(),
          right: viewBounds.getRight()
        }
      }
    }))
    this.api.venues({
      ...this.state.search,
      ...this.state.map.viewBounds
    })
        .then(({ data, meta }) => {
          this.setState(({ venues, map }) => ({
            loading: false,
            venues: {
              ...venues,
              ...meta,
              all: data
            },
            map: {
              ...map,
              dirty: false
            }
          }))
        })
  }

  searchGlobally = () => {
    this.setState({ loading: true })
    this.api.venues({
      ...this.state.search
    })
        .then(({ data, meta }) => {
          let viewBounds = DEFAULT_VIEW_BOUNDS
          if (data.length > 0) {
            const bounds = getBounds(data.map(venue => ({
              latitude: venue.attributes.latitude,
              longitude: venue.attributes.longitude
            })))

            viewBounds = {
              top: bounds.minLat,
              left: bounds.minLng,
              bottom: bounds.maxLat,
              right: bounds.maxLng
            }
          }

          this.setState(({ venues, map }) => {
            const state = {
              loading: false,
              venues: {
                ...venues,
                ...meta,
                all: data
              },
              map: {
                ...map,
                viewBounds: viewBounds,
                dirty: false
              }
            }

            if (data.length === 1) {
              state.map.zoom = DEFAULT_ZOOM
            }

            return state
          })
        })
  }

  handleJumpToGeolocationClick = () => {
    geolocation.position
        .then(center => this.setState(({ map }) => ({
          map: { ...map, center, zoom: DEFAULT_ZOOM, dirty: true }
        })))
  }

  render ({ host, hereMapsId, hereMapsCode }, { error, booting, loading, venues, map, search }) {
    if (error) {
      return (
          <div class="initialize-size">
          <i class="fa fa-exclamation-triangle mr-4"></i>
      Es ist ein Fehler aufgetreten.
      </div>
    )
    }

    if (booting) {
      return (
          <div class="initialize-size">
          <i class="fa fa-spinner fa-spin mr-4"></i>
      Kartenansicht wird generiert
      </div>
    )
    }

    const displaySearchInArea = map.dirty && map.zoom >= 5
    const searchHasBeenLimited = venues.all.length < venues.total_count
    const searchHasNoResults = venues.all.length === 0

    return (
        <div class='appointment-search'>
        <div class='appointment-search__container'>
        <Map
    apikey={HERE_MAPS_APIKEY}
    center={map.center}
    zoom={map.zoom}
    viewBounds={map.viewBounds}
    onMapviewchangeend={this.handleMapViewChanged}
    onDragstart={this.handleDragStart}
    onWheel={this.handleWheel}
    onload={this.searchGlobally}
        >
        <Cluster onTap={this.selectVenue} dataPoints={venues.all.map(({id, attributes}) => [
        attributes.latitude,
        attributes.longitude,
        1,
        { id, ...attributes }
      ])} />
    </Map>
    <div class='appointment-search__actions'>
        <div class='appointment-search__actions__center'>
        {displaySearchInArea && <button disabled={loading} onClick={this.searchWithinBounds} class="btn btn-secondary"><i class="fa fa-refresh"></i> In diesem Bereich suchen</button>}
  </div>
    <div class='appointment-search__actions__right'>
        {geolocation.supported && <button onClick={this.handleJumpToGeolocationClick} class="btn btn-secondary"><i class="fa fa-crosshairs"></i></button>}
  </div>
    </div>
    </div>
    <div class="box gray legend p-2">

        <div class="legend-item">
        <svg xmlns="http://www.w3.org/2000/svg" class="mr-3 float-left" viewBox="0 0 57 38"><path fill="#898989" stroke="#fff" stroke-miterlimit="10" stroke-width="3" d="M6 10h16.94L28 5l5 5h18v23H6V10z"/></svg>
        <div class="pt-1">
        Spendetermine
        </div>
        </div>
        <div class="legend-item">
        <svg viewBox="0 0 100 100" class="mr-1 float-left" xmlns="http://www.w3.org/2000/svg"><path fill="none" d="M-1-1h102v102H-1z"/><g><path d="M11.5 36.948h25.448V11.5h26.104v25.448H88.5v26.104H63.052V88.5H36.948V63.052H11.5V36.948z" stroke-width="12" stroke="#fff" fill="#bc1624"/><path stroke="null" d="M14.5 37.965h23.465V14.5h24.07v23.465H85.5v24.07H62.035V85.5h-24.07V62.035H14.5v-24.07z" stroke-width="8" fill="#bc1624"/></g></svg>
    <div class="pt-1">Institut / Spendezentrum</div>
        </div>

        </div>
    {searchHasNoResults && <div class='appointment--search__hint alert alert-danger mt-3'>
        <i class="fa fa-exclamation-triangle mr-1"></i>
      Ihre Suche hat keine Treffer erzielt.
    </div>}
      {searchHasBeenLimited && <div class='appointment--search__hint alert alert-info mt-3'>
          Es wurden mehr Termine gefunden, als auf der Karte dargestellt werden können.<br />Bitte schränken Sie Ihre Suche ein oder zoomen in die Karte, um alle relevanten Termine zu finden.
      </div>}
      <div ref={node => this.venueContainer = node}>
        {
          venues.selectedId &&
          <Fetch
          transform={transformVenueData}
          onload={() => { this.venueContainer.scrollIntoView({ behavior: 'smooth' }) }}
          src={this.urls.venue({
                  id: venues.selectedId,
                  term: search.term,
                  start_on: search.startOn,
                  end_on: search.endOn
                })}
              >
              {state => <VenueShow urls={this.urls} {...state} />}
        </Fetch>
        }
        </div>
        </div>
        )
  }
}

export default Widget
